export default __webpack_public_path__ + "static/media/credit_card.6fa81a11.svg";